// extracted by mini-css-extract-plugin
module.exports = {"analysis":"analysis_analysis__2jVFv"};